import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { tosText, researcherHeader } from '../assets/terms'; // Import the TOS text and header

const TermsOfServiceDialog = ({ open, onClose }) => {
  const termsAccepted = localStorage.getItem('termsAccepted') === 'true';

  const handleAccept = () => {
    if (!termsAccepted) {
      localStorage.setItem('termsAccepted', 'true');
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Terms of Service</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" component="p" style={{ marginBottom: '16px' }}>
          {researcherHeader}
        </Typography>
        <Typography
          variant="body2"
          component="div"
          style={{
            maxHeight: '400px',
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
            border: '1px solid #ccc',
            padding: '8px',
            fontFamily: 'monospace',
          }}
        >
          {tosText}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAccept} color="primary" variant="contained">
          {termsAccepted ? 'Close' : 'Accept'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsOfServiceDialog; 